export default "__VITE_ASSET__Dx42dGXQ__"